import { render, staticRenderFns } from "./WelcomeScreen.vue?vue&type=template&id=695f95aa&scoped=true"
import script from "./WelcomeScreen.vue?vue&type=script&lang=js"
export * from "./WelcomeScreen.vue?vue&type=script&lang=js"
import style0 from "./WelcomeScreen.vue?vue&type=style&index=0&id=695f95aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695f95aa",
  null
  
)

export default component.exports